import { Component, DestroyRef, inject, signal, PLATFORM_ID } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { LucideAngularModule, CheckCircle2, Send } from 'lucide-angular';
import { LeadApplicationsService } from '../../../core/services/lead-applications.service';

@Component({
  selector: 'app-apply-form',
  standalone: true,
  imports: [FormsModule, LucideAngularModule, TranslatePipe],
  templateUrl: './apply-form.component.html',
})
export class ApplyFormComponent {
  private platformId = inject(PLATFORM_ID);
  private leads = inject(LeadApplicationsService);
  private readonly translate = inject(TranslateService);
  private readonly destroyRef = inject(DestroyRef);

  submitting = signal(false);
  success = signal(false);
  error = signal('');
  form = { fullName: '', phoneNumber: '', businessType: '', companyName: '', notes: '' };

  readonly CheckCircle2 = CheckCircle2;
  readonly Send = Send;

  submit() {
    if (
      !this.form.fullName.trim() ||
      !this.form.phoneNumber.trim() ||
      !this.form.businessType.trim()
    ) {
      this.error.set(this.translate.instant('LANDING.APPLY.ERROR_REQUIRED'));
      return;
    }
    this.submitting.set(true);
    this.error.set('');
    this.success.set(false);
    this.leads
      .create({
        fullName: this.form.fullName,
        phoneNumber: this.form.phoneNumber,
        businessType: this.form.businessType,
        companyName: this.form.companyName || null,
        notes: this.form.notes || null,
      })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res) => {
          this.submitting.set(false);
          if (res.success !== false) {
            this.success.set(true);
            this.form = {
              fullName: '',
              phoneNumber: '',
              businessType: '',
              companyName: '',
              notes: '',
            };
          } else {
            this.error.set(
              res.message ??
                res.errors?.join(' ') ??
                this.translate.instant('LANDING.APPLY.ERROR_FALLBACK'),
            );
          }
        },
        error: (err) => {
          this.submitting.set(false);
          this.error.set(
            err?.error?.message ??
              err?.error?.errors?.join?.(' ') ??
              this.translate.instant('LANDING.APPLY.ERROR_FALLBACK'),
          );
        },
      });
  }

  scrollToApply() {
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('apply')?.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
